import { todayIso } from '../calendar/calendarUtils.js';

export { todayIso, addDays } from '../calendar/calendarUtils.js';

export function formatRange(start: string, end: string): string {
  if (!start && !end) return 'No range selected';
  if (start === end) return start;
  return `${start} – ${end}`;
}

export function defaultRange(): { start_date: string; end_date: string } {
  const start = todayIso();
  const end = new Date(start);
  end.setDate(end.getDate() + 6);
  const y = end.getFullYear();
  const m = String(end.getMonth() + 1).padStart(2, '0');
  const d = String(end.getDate()).padStart(2, '0');
  return { start_date: start, end_date: `${y}-${m}-${d}` };
}
